import styled from 'styled-components'
import Close from 'shared/components/icons/close'
import TapLink from 'shared/components/tap-link'

const Container = styled(TapLink)`
    align-self: flex-start;
`
const BackButton = ({ className = '', onTapAction = null }) => (
    <Container className={className} onTap={onTapAction || (() => history.back())}>
        <Close />
    </Container>
)

export default BackButton
